"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M9 8.5h6v2H9zM7.51 12h9v2h-9z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M22 2H2v20h20zm-4 15h-1.5v-1.5h-9V17H6v-6.32l1.5-.01V7h9v3.67H18z"
}, "1")], 'BedroomChildSharp');